import { AvtGateway, HttpRequest } from '../../../kernel/avt.gateway'
import { AuthRepository } from '../domain/auth.repository'

export const authRepository: AuthRepository = {
  setPermissionsStytch: async (): Promise<void> => {
    const request: HttpRequest = {
      method: 'POST',
      endpoint: '/odin/api/auth/stytch/permissions'
    }

    await AvtGateway.executePostRequest({
      ...request
    })
  }
}
